import { gql } from '@apollo/client';
import { PROMPT_FIELDS } from '../fragments/prompt';

gql`
  ${PROMPT_FIELDS}
  mutation CreatePrompt($input: CreatePromptInput!) {
    admin {
      createPrompt(input: $input) {
        ...PromptFields
      }
    }
  }
`;

gql`
  ${PROMPT_FIELDS}
  mutation UpdatePrompt($id: Int!, $input: UpdatePromptInput!) {
    admin {
      updatePrompt(id: $id, input: $input) {
        ...PromptFields
      }
    }
  }
`;

gql`
  mutation DeletePrompts($ids: [Int!]!) {
    admin {
      deletePrompts(ids: $ids)
    }
  }
`;
